<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/bs3mFd/tc-custom/9781595585820.jpg?1718282660419" alt="This image is the cover for the book Pyramid, The Kurt Wallander Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Pyramid, The Kurt Wallander Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>The story of the Swedish detective’s beginnings, told in five gripping short mysteries: “An indispensable chapter to the saga” (<i>Booklist Online</i>).</b><br/>  <br/> Here are the stories that trace, chronologically, Kurt Wallander’s growth from a rookie cop into a young father and then a middle-aged divorcé, illuminating how he became a first-rate detective and highlighting new facets of the character who “remains one of the most impressive and credible creations of crime fiction today” (<i>The Guardian</i>).<br/>  <br/> “Wallander’s First Case” introduces us to the twenty-one-year-old patrolman on his first homicide case: his next-door neighbor, seemingly dead by his own hand. In “The Man with the Mask”, Wallander is a young father confronting an unexpected threat on Christmas Eve. On the brink of middle age, he is troubled by a distant wife as he unravels the poisoning of a lonely vacationer in “The Man on the Beach.” Newly separated in “The Death of the Photographer,” Wallander investigates the brutal murder—and the well-concealed secrets—of the local studio photographer. In the title story, he is a veteran detective uncovering unexpected connections between a downed mystery plane and the assassination of a pair of elderly sisters.<br/>  <br/> Written from the unique perspective of an author looking back on the life of his own character, these mysteries are vintage Henning Mankell and essential reading for fans of the fiction series or the BBC program <i>Wallander </i>starring Kenneth Branagh. <i>The Pyramid </i>is a wonderful display of Mankell’s virtuosity powers as “the unrivalled master of Swedish crime fiction and one of the finest practitioners of the genre anywhere” (<i>Toronto Star</i>).
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Henning Mankell, Ebba Segerberg
      </h2>
      
      <p class="authorDescription body article">Henning Mankell&#39;s Kurt Wallander mysteries are global bestsellers and have been adapted for television as a BAFTA Award&ndash;winning BBC series starring Kenneth Branagh. Mankell was awarded the Crime Writers&rsquo; Association&rsquo;s Macallan Gold Dagger and the German Tolerance Prize, among many others. He divides his time between Sweden and Mozambique.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Perseus
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?322c185a